import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import * as Global from '../../../../global';

export type ConfirmDialogType = 'confirm' | 'danger' | 'warning';

export interface ConfirmDialogData {
  title: string;
  message: string;
  cancelText: string;
  saveText: string;
  remarks_box?: boolean;
  remarks_is_required?: boolean;
  /** Visual accent for the icon badge + confirm button. Defaults to 'confirm'. */
  type?: ConfirmDialogType;
  /** Material icon name for the badge. Defaults to the icon for `type`. */
  icon?: string;
}

const ICON_BY_TYPE: Record<ConfirmDialogType, string> = {
  confirm: 'help_outline',
  warning: 'warning_amber',
  danger: 'delete_outline',
};

@Component({
  selector: 'app-confirm',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.scss',
})
export class ConfirmComponent {
  Global = Global;
  formGroup!: FormGroup;
  type: ConfirmDialogType;
  icon: string;
  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private fb: FormBuilder
  ) {
    this.type = this.data.type ?? 'confirm';
    this.icon = this.data.icon ?? ICON_BY_TYPE[this.type];
    this.formGroup = this.fb.group({
      remarks: [
        null,
        this.data.remarks_is_required
          ? Validators.required
          : Validators.nullValidator,
      ],
    });
  }

  onConfirm(): void {
    if (this.data.remarks_is_required) {
      this.formGroup.markAllAsTouched();
      if (this.formGroup.valid) {
        this.dialogRef.close({
          confirm: true,
          remarks: this.formGroup.getRawValue()?.remarks,
        });
      }
    } else {
      this.dialogRef.close({
        confirm: true,
        remarks: this.formGroup.getRawValue()?.remarks,
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close({ discard: true });
  }
  closeModal() {
    this.dialogRef.close(false);
  }
}
